module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-cooper-mill-finish-722-scale.b23e980d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-cooper-mill-finish-722-scale.jpg
// module id = 1123
// module chunks = 37